import { render, staticRenderFns } from "./DestinationsOfSupplier.vue?vue&type=template&id=df800de6"
import script from "./DestinationsOfSupplier.vue?vue&type=script&lang=js"
export * from "./DestinationsOfSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports